module.exports = __webpack_public_path__ + "static/media/favicon.d0c59415.ico";